<template>
  <div
    id="leaderList"
    class="mainCard"
  >
    <div class="filter">
      <el-input
        v-model="filterText"
        class="filterText"
        :placeholder="$t('common.search')"
        @change="loadUsers('change')"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="loadUsers"
        />
      </el-input>
    </div>

    <el-table
      v-loading="loading"
      :data="users"
      style="width: 100%;"
      class="usersList clear-table"
      :empty-text="$t('oa.leader.noData')"
      @row-click="goToUser"
      @sort-change="sortChange"
    >
      <el-table-column
        :label="$t('common.name')"
        class="firstCol"
        :min-width="140"
      >
        <template slot-scope="scope">
          {{ `${scope.row.first_name} ${scope.row.last_name}` }}
        </template>
      </el-table-column>
      <el-table-column
        prop="subgroup"
        :label="$t('common.team')"
        :min-width="100"
        sortable="custom"
      />
      <el-table-column
        :label="$t('coach.coach')"
        :min-width="100"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.selected_coach">
            {{ scope.row.selected_coach }}
          </div>
          <div v-else>
            -
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('common.lgaLong')"
        :min-width="140"
      >
        <template
          slot-scope="scope"
        >
          <div v-if="scope.row.lga">
            <div style="word-break: break-word;">
              {{ scope.row.lga.lga1 ? `1. ${scope.row.lga.lga1}` : '-' }}
              <br />
              {{ scope.row.lga.lga2 ? `2. ${scope.row.lga.lga2}` : '' }}
            </div>
          </div>
          <div v-else>
            -
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('session.sessionCap')"
        width="100"
        align="center"
        prop="session_number"
        sortable="custom"
      >
        <template slot-scope="scope">
          <div class="sessionStatus">
            {{ scope.row.session_id | formatSession }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="prev, pager, next"
      :total="count"
      :pager-count="5"
      :current-page.sync="currentPage"
      @current-change="loadUsers"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import api from '@/api';

export default {
  filters: {
    formatSession(value) {
      let text = '0';
      if (value.includes('session_')) {
        text = value.replace('session_', '');
      }

      return text;
    },
  },

  data() {
    return {
      filterText: '',
      filterSelect: 'search',
      sortField: '',
      sortOrder: '',
      users: [],
      currentPage: 1,
      count: 0,
      loading: false,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },

  created() {
    this.loadUsers();
  },

  methods: {
    async loadUsers(status) {
      try {
        this.loading = true;
        let response = {};
        const param = {};

        if (this.user && this.user.organization && this.user.organization.uuid) {
          param.org_uuid = this.user.organization.uuid;
        }

        if (status === 'change') {
          this.currentPage = 1;
          param.page = this.currentPage;
        } else {
          param.page = this.currentPage;
        }

        if (this.filterSelect && this.filterText) {
          param[this.filterSelect] = this.filterText;
        }

        if (this.sortField && this.sortOrder) {
          param.sort_field = this.sortField;
          param.sort_order = this.sortOrder;
        }

        response = await api.getLeaders(param);

        this.users = response.data.results;
        this.count = response.data.count;
        this.loading = false;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
        this.loading = false;
      }
    },

    sortChange({ prop, order }) {
      this.sortField = prop;
      switch (order) {
        case 'descending':
          this.sortOrder = 'DESC';
          break;
        case 'ascending':
          this.sortOrder = 'ASC';
          break;
        default:
          this.sortField = null;
          this.sortOrder = null;
      }

      this.loadUsers();
    },

    goToUser(row) {
      this.$router.push({ name: 'leaderDetail', params: { id: row.uuid } }).catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
  #leaderList {
    .filter {
      margin: 0 auto 18px;
      text-align: right;

      .filterText {
        height: 30px;
        width: 250px;
        max-width: 50%;
        border-bottom: 1px solid var(--themeFontColor);
      }
    }
  }
</style>

<style lang="scss">
  #leaderList {
    .filter {
      .filterText {
        input {
          background-color: transparent;
          color: var(--themeFontColor);
          border: none;
          border-radius: 0;
          padding: 0 2px;
        }

        .el-input-group__append {
          background-color: transparent;
          border: none;
          color: var(--themeFontColor);
          font-size: 16px;
          padding: 0 20px 0 5px;

          .el-button {
            padding: 5px;
          }
        }
      }

      .el-select {
        width: 150px;
        max-width: 40%;

        .el-input {
          input {
            border-radius: 20px;
            background-color: transparent;
            color: var(--themeFontColor);
          }
        }
      }
    }

    .usersList {
      tr {
        cursor: pointer;
      }

      .el-table__header {
        tr {
          th:first-child {
            padding-left: 15px;
          }
        }
      }

      .el-table__row {
        td:first-child {
          padding-left: 15px;
        }
      }
    }
  }
</style>
